import script from "./ProductCourseComments.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCourseComments.vue?vue&type=script&setup=true&lang=js"

import "./ProductCourseComments.vue?vue&type=style&index=0&id=5196d888&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5196d888"]])

export default __exports__